import React from 'react'
import { trackAppStoreClick } from '../analytics'

const img = (name: string) => `${process.env.PUBLIC_URL}/images/${name}`
const APP_STORE_URL = 'https://apps.apple.com/us/app/heard-epub-text-to-speech/id6785654562'

const ODYSSEY_SHOTS = [
  {
    image: 'heard-search-odyssey.jpg',
    alt: 'Searching for The Odyssey in Heard',
  },
  {
    image: 'heard-odyssey.jpg',
    alt: 'Reading The Odyssey ebook in Heard',
  },
  {
    image: 'heard-odyssey-chrome.jpg',
    alt: 'The Odyssey narration controls in Heard',
  },
  {
    image: 'heard-odyssey-chrome2.jpg',
    alt: 'The Odyssey read aloud in Heard',
  },
]

export default function Odyssey() {
  return (
    <>
      <section className="odyssey-hero">
        <div className="container odyssey-hero-inner">
          <div className="odyssey-copy">
            <div className="eyebrow">Free ebook for iPhone</div>
            <h1>Read The Odyssey for free</h1>
            <p className="tag">
              Start Homer&apos;s epic in Heard, then listen as it reads aloud with on-device
              narration.
            </p>
            <p className="sub">
              Christopher Nolan&apos;s upcoming <em>The Odyssey</em>, starring Matt Damon as
              Odysseus, arrives July 17, 2026. Read the public-domain classic now and hear the
              story as you go.
            </p>
            <div className="hero-cta odyssey-cta">
              <a
                id="app-store-odyssey-hero"
                className="btn"
                href={APP_STORE_URL}
                target="_blank"
                rel="noreferrer"
                onClick={() => trackAppStoreClick('app-store-odyssey-hero')}
              >
                Get Heard on the iOS App Store
              </a>
            </div>
            <p className="free-note">Free to read and listen with the default voice. No account needed.</p>
          </div>
          <div className="odyssey-hero-media">
            <img className="phone odyssey-phone-main" src={img('heard-odyssey.jpg')} alt="The Odyssey ebook open in Heard" />
            <img className="phone odyssey-phone-side" src={img('heard-odyssey-chrome.jpg')} alt="The Odyssey read aloud in Heard" />
          </div>
        </div>
      </section>

      <section className="odyssey-band">
        <div className="container">
          <div className="odyssey-points">
            <div>
              <h2>Open the book instantly</h2>
              <p>The Odyssey is included in Heard&apos;s free library of public-domain classics.</p>
            </div>
            <div>
              <h2>Listen page by page</h2>
              <p>Tap play and Heard generates natural narration directly on your iPhone.</p>
            </div>
            <div>
              <h2>Read anywhere</h2>
              <p>No account, no streaming, and no server required once the book is on your device.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="odyssey-gallery">
        <div className="container">
          <div className="odyssey-section-heading">
            <div className="eyebrow">The Odyssey in Heard</div>
            <h2>Read it. Hear it. Keep your place.</h2>
          </div>
          <div className="odyssey-shots">
            {ODYSSEY_SHOTS.map((shot) => (
              <img key={shot.image} className="phone" src={img(shot.image)} alt={shot.alt} loading="lazy" />
            ))}
          </div>
          <div className="odyssey-bottom-cta">
            <a
              id="app-store-odyssey-bottom"
              className="btn"
              href={APP_STORE_URL}
              target="_blank"
              rel="noreferrer"
              onClick={() => trackAppStoreClick('app-store-odyssey-bottom')}
            >
              Download Heard for iOS
            </a>
          </div>
        </div>
      </section>
    </>
  )
}
